import React, { Component } from 'react';
import Dialog from 'material-ui/Dialog';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import Checkbox from 'material-ui/Checkbox';
import DialogContent from '@material-ui/core/DialogContent';
import theme from '../../muiTheme';

const styles = {
  errorDialogContent: {
    width: "500px"
  },
  errorDialogTitle: {
    color: theme.palette.accent1Color
  }
};

export class CertifyDialog extends Component
{

  constructor(props)
  {
     super(props);

     this.state =
     {
       canCertifyIncident: false
     };
   }

render() {

    return (

      <Dialog
       titleStyle={styles.errorDialogTitle}
       title="Certify Incident"
       open={this.props.open}>
              <DialogContent>
              <div style={{padding: "5px 5px 5px 5px"}}>
              <Checkbox
              label="By checking this box, you are applying your electronic signature."
              onCheck={(e, checked) =>
                {
                    this.setState({canCertifyIncident: checked});
                }}
               />
               </div>

              </DialogContent>
       <DialogActions>
        <Button onClick={this.props.onCertifyIncidentCancel} color="primary">
          Cancel
        </Button>
          <Button onClick={this.props.onCertifyIncident} color="primary" disabled={!this.state.canCertifyIncident}>
            Certify Incident
        </Button>
      </DialogActions>
     </Dialog>
    )
  }
}

export default CertifyDialog;
